import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 178.07 55.36"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M13.55 54.68c8.22-8.21 18.23-14.79 34.39-14.35 20.61.56 36.97 7.53 55.07 11.84-3.5.73-6.16 1.65-12.16 1.7-15.21.13-32.05-9.43-47.93-9.08-12.13-.22-20.57 5.1-29.36 9.89Z",
      style: {"fill":"#151398","stroke":"#000","stroke-miterlimit":"15.12","stroke-width":".32px"}
    }, null, -1),
    _createElementVNode("path", {
      d: "M9.59 45.14C19.84 35.34 32.33 27.47 52.47 28c25.71.67 46.11 8.99 68.68 14.14-4.36.87-7.69 1.97-15.17 2.03-18.97.16-39.97-11.26-59.78-10.85-15.13-.26-25.65 6.1-36.61 11.82Z",
      style: {"fill":"#0398f9"}
    }, null, -1),
    _createElementVNode("path", {
      d: "M4.56 36.94C17.52 24.11 33.32 13.8 58.8 14.49c32.52.88 58.32 11.78 86.87 18.52-5.51 1.14-9.72 2.58-19.19 2.66-24 .2-50.55-14.75-75.61-14.21-19.14-.34-32.44 7.98-46.31 15.47Z",
      style: {"fill":"#8cd701"}
    }, null, -1),
    _createElementVNode("path", {
      d: "M0 28.3C16.36 12.15 36.29-.83 68.45.04c41.03 1.11 73.6 14.83 109.62 23.31-6.96 1.43-12.27 3.25-24.22 3.35-30.28.26-63.79-18.57-95.41-17.88C34.29 8.39 17.5 18.87 0 28.3Z",
      style: {"fill":"#e40098"}
    }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "JY-logo"}) } }